import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {hideAnimationForm, showForm} from '../store/action/animationForm'
import {backPrevForm, saveData, saveHistory, showRezultForm, submitData} from '../store/action/stateForm'

import StepNavigation from './StepNavigation';
import GeneralInformation from './Forms/GeneralInformation';
import Documents from './Forms/Documents';
import Work from './Forms/Work';
import Temp from './Forms/Temp';
import Header from './Header';
import { parseDataForms } from './utils/utils'
import Confirm from './Forms/Confirm'


class Content extends React.Component{
  handleSubmit = (formData, onlySave) => {
    const {lastForm, onSubmitData, userData, onCreate} = this.props
    if(lastForm){
      const newData = Object.assign(userData, formData)
      onCreate(newData)
    } else {
      onSubmitData(formData, onlySave)
    }
  }
  showNotValidForm = () => {
    // eslint-disable-next-line max-len
    const msg = `<h1 class="title">Ідентифікаційні дані не підтверджено</h1><div class='text'><p>Шановний клієнте! Для замовлення карти Вам необхідно звернутися з документами, що підтверджують особу, у відділення АБ «УКРГАЗБАНК» для оновлення ідентифікаційних даних. Дякуємо за довіру!</p> </div> `
    this.props.onShowRezultForm(msg, true)
  }

  sendHistory = (fieldData) => {
    const {userData} = this.props
      const formData = {
        ...fieldData,
        applicationId: userData.applicationId,
        oldValue: fieldData.oldValue || this.getDefaultOldValue(fieldData.newValue)
      }

      this.props.onSaveHistory(formData)
  }

  getDefaultOldValue = (value) => {
    let type = typeof value
    if(type === 'number') return 0

    if(type === 'boolean') return false

    return ''
  }

  checkRenderComponent = () => {
    const {nameForm, userData, derictory, onShowForm, blockedFields, isClient} = this.props
    switch(nameForm){
      case 'GeneralInformation':
        return <GeneralInformation
                showNotValidForm={this.showNotValidForm}
                blockedFields={blockedFields}
                onSubmitData={this.handleSubmit}
                userData={parseDataForms('GeneralInformation', userData)}
                isClient={isClient}
                sendHistory={this.sendHistory}
        />
      case 'Documents':
        return <Documents
                onShowForm={onShowForm}
                onSubmitData={this.handleSubmit}
                userData={parseDataForms('Documents', userData)}
                derictory={derictory}
                isClient={isClient}
                blockedFields={blockedFields}
                showNotValidForm={this.showNotValidForm}
                sendHistory={this.sendHistory}
        />
      case 'Work':
        return <Work
                onShowForm={onShowForm}
                onSubmitData={this.handleSubmit}
                userData={parseDataForms('Work', userData)}
                derictory={derictory}
                sendHistory={this.sendHistory}
        />
      case 'Сonfirm':
        return <Confirm onSubmitData={this.handleSubmit} />
      case 'Temp':
        return <Temp />
      default:
        return ''
    }
  }

  onClickBack = () => {
    const {animeteFormState, onHideAnimationForm, onGoPrevForm, numberForm} = this.props
    if(animeteFormState)
      onHideAnimationForm()
    else if(numberForm - 1 > 0) 
      onGoPrevForm()
    else
      window.location.assign('#q=goback')
  }
  render(){
    const {numberForm, stateForm} = this.props
    return (
      <React.Fragment>
      <Header onClickBack={this.onClickBack}/>
      <div className="content-container">
        <StepNavigation numberForm={numberForm} allCount={stateForm.countStep}/>
        <div className="content-container-wrap wrap">
          {this.checkRenderComponent()}
        </div>
      </div>
      </React.Fragment>
    )
  }
}

Content.propTypes = {
  animeteFormState: PropTypes.bool.isRequired,
  nameForm: PropTypes.string.isRequired,
  onHideAnimationForm: PropTypes.func.isRequired,
  onGoPrevForm: PropTypes.func.isRequired,
  numberForm: PropTypes.number.isRequired,
  stateForm: PropTypes.shape({
    countStep: PropTypes.number.isRequired,
  }),
  lastForm: PropTypes.bool.isRequired,
  onSubmitData: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  derictory: PropTypes.object.isRequired, 
  onCreate: PropTypes.func.isRequired,
  onShowForm: PropTypes.func.isRequired,
  onShowRezultForm: PropTypes.func.isRequired,
  blockedFields: PropTypes.object,
  isClient: PropTypes.number,
  onSaveHistory: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  nameForm: state.stateForm.stepNameForm,
  numberForm: state.stateForm.numberStepForm,
  stateForm: state.stateForm,
  animeteFormState: state.animationForm.show,
  lastForm: state.stateForm.lastForm,
  userData:  state.stateForm.userData,
  blockedFields:  state.stateForm.blockedFields,
  derictory: state.derictory,
  isClient: state.stateForm.isClient
})

const mapDispatchToProps = dispatch => ({
  onHideAnimationForm: () => dispatch(hideAnimationForm()),
  onGoPrevForm: () => dispatch(backPrevForm()),
  onShowForm: (nameForm, title, value) => dispatch(showForm(nameForm, title, value)),
  onSubmitData: (formData, onlySave) => dispatch(saveData(formData, onlySave)),
  onCreate: data => dispatch(submitData(data)),
  onShowRezultForm: (message, showButtonResult) => dispatch(showRezultForm(message, showButtonResult)),
  onSaveHistory: (data) => dispatch(saveHistory(data))
})
export default connect(mapStateToProps, mapDispatchToProps)(Content)